const createNewPlaylist = `data:image/svg+xml;utf8,
<svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg">
  <g transform="matrix(1, 0, 0, 1, 17.860416, -12.87587)">
    <rect x="24.397" width="300" height="44.456" style="stroke-linejoin: round;" rx="15.462" ry="15.462" y="69.126"/>
    <rect x="24.397" width="300" height="44.456" style="stroke-linejoin: round;" rx="15.462" ry="15.462" y="226.133"/>
    <rect x="24.397" width="220" height="44.456" style="stroke-linejoin: round;" rx="15.462" ry="15.462" y="383.14"/>
    <rect x="165.343" width="154.83" height="37.651" style="stroke-linejoin: round;" rx="15.462" ry="15.462" y="198.189" transform="matrix(0, 1, -1, 0, 591.267883, 160.384995)"/>
    <rect x="296.838" width="154.83" height="37.651" style="stroke-linejoin: round;" rx="15.462" ry="15.462" y="384.317"/>
  </g>
</svg>`;

export { createNewPlaylist };
